const dateFormat = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  timeZone: "Europe/London",
});
const timeFormat = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: "Europe/London",
});
export function historyDate(date: Date) {
  return dateFormat.format(new Date(date));
}
export function timestamp(date: Date) {
  return `${historyDate(date)} at ${timeFormat.format(new Date(date))}`;
}
